export default __webpack_public_path__ + "static/media/a011-market-1.c5eceb34.svg";